/**
 * "Governance" — Dashboard section (ADR-0074).
 * Reconciled from apps/web capability-governance (route /governance),
 * tool-availability (route /tool-availability, the act-as-user per-user targeting
 * surface) and abilities (route /abilities, widget-registered host actions).
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_GOVERNANCE_PAGE: DocPageContent = {
  slug: 'dashboard/governance',
  titleKey: 'docs.dashboard.governance.title',
  descriptionKey: 'docs.dashboard.governance.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.governance.lead' },

    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.dashboard.governance.default.title',
      textKey: 'docs.dashboard.governance.default.body',
    },

    {
      kind: 'heading',
      level: 2,
      id: 'capabilities',
      textKey: 'docs.dashboard.governance.caps.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.governance.caps.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.governance.caps.item.enabled',
        'docs.dashboard.governance.caps.item.approval',
        'docs.dashboard.governance.caps.item.sideEffect',
      ],
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.governance.caps.bulk' },

    {
      kind: 'heading',
      level: 2,
      id: 'availability',
      textKey: 'docs.dashboard.governance.avail.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.governance.avail.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.governance.avail.item.signedIn',
        'docs.dashboard.governance.avail.item.scopes',
        'docs.dashboard.governance.avail.item.attributes',
        'docs.dashboard.governance.avail.item.advanced',
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      textKey: 'docs.dashboard.governance.avail.note',
      links: {
        actAsUser: {
          target: { docSlug: 'guides/act-as-user' },
          labelKey: 'docs.dashboard.governance.avail.note.link',
        },
      },
    },

    {
      kind: 'heading',
      level: 2,
      id: 'abilities',
      textKey: 'docs.dashboard.governance.abilities.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.governance.abilities.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.governance.abilities.item.killswitch',
        'docs.dashboard.governance.abilities.item.active',
        'docs.dashboard.governance.abilities.item.confirm',
      ],
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.governance.next.catalog.title',
          textKey: 'docs.dashboard.governance.next.catalog.text',
          to: { docSlug: 'catalog' },
        },
        {
          titleKey: 'docs.dashboard.governance.next.confirm.title',
          textKey: 'docs.dashboard.governance.next.confirm.text',
          to: { docSlug: 'confirmation' },
        },
      ],
    },
  ],
};
